<template>
  <span v-if="outputs.length === 0" class="text-danger">
    <i class="fas fa-exclamation-triangle"></i>
  </span>
  <span v-else>
    <span v-for="(output, index) in outputs" :key="index">
      <span>{{ output.title }}<i v-if="output.nullable" class="fas fa-question ms-1" style="font-size: 0.9em"></i></span>
      <i v-if="index < outputs.length - 1" class="text-light fas fa-caret-right mx-1" style="font-size: 0.75em"></i>
    </span>
  </span>
</template>

<script>
export default {
  name: "OutputView",
  props: {
    trigger: Object,
    outputPath: String,
    dataTypes: Array
  },
  computed: {
    outputs() {
      let list = [];
      let split = this.outputPath.split(".");
      let rootOutput = this.trigger.outputs.find(item => item.key === split[0]);
      for (let i = 1; i <= split.length; i++) {
        let output = this.getOutput(rootOutput, split.slice(0, i));
        if (!output) return [];
        output.path = split.slice(0, i).join(".");
        list.push(output);
      }
      return list;
    }
  },
  methods: {
    getOutput(current, path, pathBuilder) {
      if (!current) return undefined;
      pathBuilder = pathBuilder ?? [];
      pathBuilder.push(current.key);
      current.type = this.dataTypes.find(item => item.key === current.type.key);
      current.path = pathBuilder.join(".");
      if (path.length === 1) return current;
      let output = current.type.outputs.find(item => item.key === path[1]);
      return this.getOutput(output, path.slice(1, path.length), pathBuilder);
    }
  }
}
</script>

<style scoped>

</style>